import React from "react";
import { cn } from "@/lib/utils";

interface PartnerPageHeaderProps {
  title: string;
  description: string;
  eyebrow?: string;
  actions?: React.ReactNode;
  className?: string;
}

const PartnerPageHeader: React.FC<PartnerPageHeaderProps> = ({
  title,
  description,
  eyebrow,
  actions,
  className,
}) => (
  <header data-partner-tour="page-heading" className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)}>
    <div className="max-w-3xl">
      {eyebrow && (
        <p className="mb-1 text-xs font-bold uppercase tracking-[0.12em] text-sky-700">{eyebrow}</p>
      )}
      <h1 className="text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">{title}</h1>
      <p className="mt-1.5 text-sm leading-6 text-slate-600 sm:text-base">{description}</p>
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </header>
);

export default PartnerPageHeader;
